import packageJson from '../../package.json';

export const environment = {
  production: true,
  version: packageJson.version,
  apiUrl: 'https://bscode.com.br/api',
  recaptcha: {
    siteKey: '6LfuVRYrAAAAAOg7L1phvCEKgOU282PuFgyZUTTB',
  },
};
